// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.import-table-cell-style-with-bg {
  text-align: center !important;
  width: 20px;
  max-width: 20px;
  text-overflow: ellipsis;
  overflow: hidden;
  background-color: #424242;
  color: white !important;
}
.import-table-cell-style {
  text-align: center !important;
  width: 20px;
  max-width: 20px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.import-table-body {
  min-width: 700;
  border: 1px solid grey;
}
`, "",{"version":3,"sources":["webpack://./src/components/import/styles/ImportTable.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB","sourcesContent":[".import-table-cell-style-with-bg {\n  text-align: center !important;\n  width: 20px;\n  max-width: 20px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  background-color: #424242;\n  color: white !important;\n}\n.import-table-cell-style {\n  text-align: center !important;\n  width: 20px;\n  max-width: 20px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.import-table-body {\n  min-width: 700;\n  border: 1px solid grey;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
